document.addEventListener('DOMContentLoaded', function () {

  var $contactInfoButton = $('#contactInfo.manage-preferences');
  $contactInfoButton.prop('disabled', true);
  
  var $contactInfoForm = $('#contactInfoForm');
  
  function enableContactInfoButton() {
      $contactInfoButton.prop('disabled', false);
  }
  
  $contactInfoForm.on('input change keyup paste', 'input[type="text"]:not(.selectivity-single-select-input)', enableContactInfoButton);
  
  $(document).on('click', '.selectivity-result-item', function() {
      if ($contactInfoForm.find(this).length || $contactInfoForm[0].contains(this)) {
          setTimeout(enableContactInfoButton, 150);
      }
  });
  
  $contactInfoForm.on('change', '.selectivity-input select', function() {
      enableContactInfoButton();
  });
  
  $contactInfoForm.on('change', '.selectivity-input', function() {
      enableContactInfoButton();
  });
});
